import {
  RC_CHECK_STATE,
  RC_CLOSE,
  RC_DISCONNECT,
  RC_ERROR,
  RC_LOGIN,
  RC_MESSAGE_ALL,
  RC_MESSAGE_NEW,
  RC_NOTIFICATION,
  RC_NOTIFICATION_CHECK,
  RC_OPEN,
  RC_REGISTER,
  RC_REQUEST,
  RC_RESPONSE,
  RC_ROOM,
  RC_ROOM_ADD,
  RC_ROOM_ALL,
  RC_ROOM_REMOVE,
  RC_SUBSCRIBE,
  RC_TYPING_RECEIVE,
  RC_USER
} from "../constants/actionTypes";
import {USER_LOGGED_OUT} from "../../../../screens/user/constants/actionTypes";
import {
  getSubscriptions,
  loadHistory,
  loadHistoryDiff,
  onRoom,
  sendOfflineMessages,
  subscribeActiveUsers,
  subscribeUserData,
  subscribeUserNotification
} from "../actions/rocketChatAction";
import { PUSH_NOTIFICATION_RECEIVED } from "../../notification/constants/actionTypes";

const defaultState = {
  notifications: [],
  subscriptions: [],
  messages: {},
  room: "",
  rooms: {},
  user: {},
  users: {},
  typings: {},
  isConnected: false,
  isLoggedIn: false,
  isChecked: true
};

export const rocketChatReducer = (state = defaultState, action) => {
  switch (action.type) {
    case USER_LOGGED_OUT:
      action.dispatch({type: RC_DISCONNECT});
      return defaultState;
    case RC_CLOSE:
      return {
        ...state,
        isConnected: false
      };
    case RC_OPEN:
      return {
        ...state,
        isConnected: true
      };
    case RC_ERROR:
      return {
        ...state,
        error: action.error
      };
    case RC_ROOM:
      return {
        ...state,
        room: action.roomName
      };
    case RC_ROOM_ADD:
      action.dispatch(onRoom(action.rid));
      return {
        ...state,
        room: "",
        rooms: {
          ...state.rooms,
          [state.room]: {
            name: state.room,
            rid: action.rid,
            unread: 0
          }
        }
      };
    case RC_ROOM_ALL:
      return {
        ...state,
        rooms: action.payload.reduce((rooms, room) => {
          action.dispatch(onRoom(room.rid));
          action.dispatch(loadHistoryDiff(room));
          action.dispatch(sendOfflineMessages(room));
          return {
            ...rooms,
            [room.name]: {
              name: room.name,
              rid: room.rid,
              unread: room.unread
            }
          };
        }, state.rooms)
      };
    case RC_ROOM_REMOVE:
      return {
        ...state,
        rooms: Object.keys(state.rooms)
          .filter((key) => key !== action.user)
          .reduce((obj, key) => {
            obj[key] = state.rooms[key];
            return obj;
          }, {})
      };
    case RC_LOGIN:
      action.dispatch(getSubscriptions());
      action.dispatch(subscribeUserNotification());
      action.dispatch(subscribeUserData());
      action.dispatch(subscribeActiveUsers());
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
          ...Object.values(state.users).find((user) => {
            return user.id === action.payload.id;
          })
        },
        isLoggedIn: true
      };
    case RC_TYPING_RECEIVE:
      return {
        ...state,
        typings: {
          ...state.typings,
          [action.user]: action.isTyping
        }
      };
    case RC_SUBSCRIBE:
      return {
        ...state,
        subscriptions: [
          ...state.subscriptions,
          `${action.payload.name} ${action.payload.event}`
        ]
      };
    case RC_USER:
      return {
        ...state,
        users: {
          ...state.users,
          [action.user.id]: {
            ...state.users[action.user.id],
            ...action.user
          }
        }
      };
    case RC_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.concat(action.notifications)
      };
    case RC_NOTIFICATION_CHECK:
      return {
        ...state,
        notifications: state.notifications.filter((item, index) => index !== action.index)
      };
    case PUSH_NOTIFICATION_RECEIVED:
      return {
        ...state,
        notifications: state.notifications.filter((item) => item.id !== action.payload.id)
      };
    case RC_CHECK_STATE:
      return {
        ...state,
        isChecked: action.payload
      };
    case RC_REGISTER:
      return {
        ...state,
        user: {
          ...state.user,
          isRegistered: true
        }
      };
    case RC_MESSAGE_NEW:
      return {
        ...state,
        messages: {
          ...state.messages,
          [action.message.rid]: [
            ...state.messages[action.message.rid] || [],
            action.message
          ]
        }
      };
    case RC_REQUEST:
      return {
        ...state,
        requests: {
          ...state.requests,
          [action.message.id]: action.message
        }
      };
    case RC_RESPONSE:
      return {
        ...state,
        responses: {
          ...state.responses,
          [action.message.id]: action.message
        }
      };
    case RC_MESSAGE_ALL:
      if (action.unreadNotLoaded > 0) {
        action.dispatch(
          loadHistory(
            action.messages[0].rid,
            action.unreadNotLoaded + action.messages.length
          )
        );
      }
      return {
        ...state,
        messages: action.messages.reverse().reduce((messages, message) => {
          if (action.unreadNotLoaded === 0 && !(messages[message.rid] || []).find((element) => {
            return element._id === message._id;
          })) {
            messages[message.rid] = (messages[message.rid] || []).concat([message]);
          }
          return messages;
        }, {...state.messages})
      };
    default:
      return state;
  }
};
